/**
 * Collaboration API client — CRUD + payments
 */
import apiClient from './client.js';

export const fetchCollaborations = (leadId) =>
  apiClient.get('/collaborations', { params: { leadId } }).then(r => r.data.collaborations);

export const createCollaboration = (payload) =>
  apiClient.post('/collaborations', payload).then(r => r.data.collaboration);

export const getCollaboration = (id) =>
  apiClient.get(`/collaborations/${id}`).then(r => r.data.collaboration);

export const updateCollaboration = (id, payload) =>
  apiClient.patch(`/collaborations/${id}`, payload).then(r => r.data.collaboration);

// STAGE-AUTO-05 (Phase 73): завершить текущий раунд + создать раунд N+1.
// Returns the full response object — caller inspects `completedOnly` flag for round-4 cap UX (D-12).
//   success     → { ok: true, collaborations: [...] }
//   round-4 cap → { ok: true, completedOnly: true, message: 'Раунды завершены — переведите лида в Амбассадоры вручную' }
export const completeAndStartNext = (collabId, payload) =>
  apiClient.post(`/collaborations/${collabId}/complete-and-start-next`, payload).then(r => r.data);

export const deleteCollaboration = (id) =>
  apiClient.delete(`/collaborations/${id}`).then(r => r.data);

// Payments
export const addPayment = (collabId, payload) =>
  apiClient.post(`/collaborations/${collabId}/payments`, payload).then(r => r.data.payment);

export const updatePayment = (collabId, pid, payload) =>
  apiClient.patch(`/collaborations/${collabId}/payments/${pid}`, payload).then(r => r.data.payment);

export const deletePayment = (collabId, pid) =>
  apiClient.delete(`/collaborations/${collabId}/payments/${pid}`).then(r => r.data);
